export enum StatusColor {
  Canceled = 'CANCELED',
  Error = 'ERROR',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING',
}
